import { jsx as _jsx } from "react/jsx-runtime";
import { logger } from '@lichtblick/logger';
import { ComboBox } from '@lichtblick/photon/molecules/combo-box';
import { useTracker } from '@lichtblick/tracker';
import { useCallback } from 'react';
const cityPromiseMap = {};
export const fetchCities = async (postcode)=>{
    let retryCount = 3;
    while(retryCount > 0){
        let response;
        try {
            response = await fetch(`/api/zip/${postcode}/`);
        } catch (_e) {
        // handled via retryCounter
        }
        if (response?.status === 200) {
            try {
                return await response.json();
            } catch (error) {
                logger.warn('[AIOC] Failed parsing cities JSON', {
                    error,
                    postcode
                });
            }
        }
        retryCount--;
        if (retryCount === 0) {
            logger.log('[AIOC] Failed to fetch cities');
        }
        await new Promise((resolve)=>setTimeout(resolve, 500));
    }
    return undefined;
};
const getCitiesCached = async (zip)=>{
    if (cityPromiseMap[zip] !== undefined) {
        return cityPromiseMap[zip];
    }
    cityPromiseMap[zip] = fetchCities(zip);
    cityPromiseMap[zip].then((cities)=>{
        if (!cities?.length) {
            cityPromiseMap[zip] = undefined;
        }
    });
    return cityPromiseMap[zip];
};
const comboBoxCallback = async (searchValue)=>{
    try {
        const postcode = searchValue.slice(0, 5).trim();
        if (!/^\d{5}/.test(postcode)) {
            return 'Bitte gib eine PLZ mit 5 Ziffern ein';
        }
        const cities = await getCitiesCached(postcode);
        if (cities === undefined) {
            return 'Unbekannter Fehler';
        }
        const results = cities.filter((city)=>{
            return city.label.toLowerCase().includes(searchValue.toLowerCase());
        });
        if (results.length === 0) {
            return 'Keine Treffer gefunden';
        }
        return results;
    } catch (error) {
        logger.warn('Failed to fetch cities', {
            error,
            searchValue
        });
        return 'Unbekannter Fehler';
    }
};
export const CityInput = ({ onChange })=>{
    const { trackCustomEvent } = useTracker();
    const handleChange = useCallback((option)=>{
        trackCustomEvent({
            eventName: 'tariff_calculator_interaction'
        }, undefined, true);
        const [postcode, city] = option.value.split('|');
        onChange(city, postcode);
    }, [
        onChange,
        trackCustomEvent
    ]);
    return /*#__PURE__*/ _jsx(ComboBox, {
        autoComplete: "postal-code",
        "data-testid": "combo-box-city",
        errorMessage: "Hier fehlt noch eine Angabe",
        inputMode: "numeric",
        label: "Ort",
        onChange: handleChange,
        optionsCallback: comboBoxCallback,
        required: true,
        searchPlaceholder: "Postleitzahl"
    });
};

//# sourceMappingURL=CityInput.js.map